/**
 * A header configuration class
 */
export class HeaderConfig {
  /** The header title */
  public title: string;

  /** The route triggered by clicking on the logout button */
  public logoutRoute: string;
}
